import { CWComponents } from "@channelwill/components"
import { observer } from "mobx-react"
import { useEffect } from "react"

import stores from "@/stores"

export const CWComponentsProvider = observer(() => {
  // 从全局存储里获取商家地址&商家的语种
  useEffect(() => {
    if (!stores.UserInfoStore.data) return
    // 组件库初始化
    CWComponents.init({
      // 根据环境变量选择对应的中台环境
      baseUrl: import.meta.env.VITE_PUBLIC_CHANNELWILL_COMPONENTS,
      // 引入组件的相关映射:
      // { 业务分类 :{' 组件唯一key值 '}}
      componentMaps: {
        recommendations: ["home_recommend_solution"],
      },
      appId: "519679133879828480",
      lang: stores.UserInfoStore.data.language_admin,
      shopifyDomain: stores.UserInfoStore.data.shop,
    })
  }, [stores.UserInfoStore.data.language_admin, stores.UserInfoStore.data.shop])
  return <></>
})
